export default __webpack_public_path__ + "static/media/Mensageria.5018fe60.svg";